/**
 * Choice values for oc_accessgroupsync (global option sets in Dataverse).
 */
export const ACCESS_GROUP_SYNC_ACTION = {
  CREATE_GROUP: 161732000,
  UPDATE_GROUP_META: 161732001,
  UPDATE_MEMBERSHIP: 161732002,
  DELETE_GROUP: 161732003
};

export const ACCESS_GROUP_SYNC_STATUS = {
  PENDING: 161732010,
  PROCESSING: 161732011,
  COMPLETED: 161732012,
  FAILED: 161732013
};

export const ACCESS_GROUP_SYNC_STATUS_LABELS = {
  [ACCESS_GROUP_SYNC_STATUS.PENDING]: 'Venter',
  [ACCESS_GROUP_SYNC_STATUS.PROCESSING]: 'Behandler',
  [ACCESS_GROUP_SYNC_STATUS.COMPLETED]: 'Fullført',
  [ACCESS_GROUP_SYNC_STATUS.FAILED]: 'Feilet'
};

export const ACCESS_GROUP_SYNC_ACTION_LABELS = {
  [ACCESS_GROUP_SYNC_ACTION.CREATE_GROUP]: 'Opprett gruppe',
  [ACCESS_GROUP_SYNC_ACTION.UPDATE_GROUP_META]: 'Oppdater metadata',
  [ACCESS_GROUP_SYNC_ACTION.UPDATE_MEMBERSHIP]: 'Oppdater medlemskap',
  [ACCESS_GROUP_SYNC_ACTION.DELETE_GROUP]: 'Slett gruppe'
};

/** Unloc update-accesses batch limit (key changes per call). */
export const ACCESS_GROUP_SYNC_BATCH_LIMIT = 9000;
